module.exports = __webpack_public_path__ + "img/secondary_3x2.cd76f3ff.svg";